var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClipboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.279 4.15a2.85 2.85 0 0 1 2.721-2h2c1.278 0 2.36.841 2.721 2H17A2.85 2.85 0 0 1 19.85 7v12A2.85 2.85 0 0 1 17 21.85H7A2.85 2.85 0 0 1 4.15 19V7A2.85 2.85 0 0 1 7 4.15zm0 1.7H7A1.15 1.15 0 0 0 5.85 7v12c0 .635.515 1.15 1.15 1.15h10A1.15 1.15 0 0 0 18.15 19V7A1.15 1.15 0 0 0 17 5.85h-1.279a2.85 2.85 0 0 1-2.721 2h-2a2.85 2.85 0 0 1-2.721-2m2.721-2a1.15 1.15 0 0 0 0 2.3h2a1.15 1.15 0 1 0 0-2.3z",
  clipRule: "evenodd"
})));
export default SvgClipboard;